import {StaticTable} from '../static.table';
import {ReRelationType} from '../../interfaces/relatives/re-relation-type';
import {db} from '../db.service';
import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ReRelationTypesTable extends StaticTable<ReRelationType> {
  constructor() {
    super(db.reRelationTypes);
  }
}
